export var Screen;
(function (Screen) {
    Screen["REGISTER"] = "Register";
    Screen["PERSONAS"] = "Personas";
    Screen["CREATE_PERSONA"] = "CreatePersona";
    Screen["SALE"] = "BirthdaySale";
    Screen["RECOMMENDATION"] = "Recommendation";
    Screen["FAVORITE_BOTS"] = "FavoriteChatbots";
    Screen["FAVORITES_LOREBOOKS"] = "FavoritesLorebooks";
    Screen["FAVORITES_GROUPS"] = "FavoritesGroups";
    Screen["SUBSCRIBE"] = "SubscriptionPage";
    Screen["GET_ACCESS"] = "GetAccess";
    Screen["BLOCKED_CREATORS"] = "BlockedCreator";
    Screen["REPORT"] = "ReportPage";
    Screen["SIGN_UP"] = "WelcomeAboard";
    Screen["PROFILE"] = "ProfileSetting";
    Screen["MY_CHATBOTS"] = "MyChatbots";
    Screen["MY_CHATS"] = "MyChats";
    Screen["HOME"] = "Home";
    Screen["EDIT_CHATBOT"] = "EditChatbot";
    Screen["LEADERBOARD"] = "Leaderboard";
    Screen["TERMS"] = "Terms";
    Screen["COMPLAINT"] = "Complaint";
    Screen["PRIVACY"] = "Privacy";
    Screen["REFUNDS"] = "Refunds";
    Screen["PAGE_2257"] = "Page2257";
    Screen["DOWNLOAD"] = "Download";
    Screen["PERSONA_EDIT"] = "EditPersona";
    Screen["CHATBOT_PROFILE"] = "ChatbotProfile";
    Screen["CREATOR_PAGE"] = "CreatorPage";
    Screen["TAG_PAGE"] = "TagPage";
    Screen["SAVED_CHATS"] = "SavedChats";
    Screen["CHAT"] = "Chat";
    Screen["CREATE_CHATBOT"] = "CreateChatbot";
    Screen["ACCOUNT"] = "Account";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- Pre-existing: SIGN_UP and WELCOME_ABOARD intentionally share the legacy "WelcomeAboard" screen id.
    Screen["WELCOME_ABOARD"] = "WelcomeAboard";
    Screen["BANNED_USER"] = "BannedUser";
    Screen["GENERATION_SETTINGS"] = "GenerationSettings";
    Screen["CHECKOUT"] = "Checkout";
    Screen["CHECKOUT_SUCCESS"] = "CheckoutSuccess";
    Screen["GROUPCHAT_PROFILE"] = "GroupchatProfile";
    Screen["DISCOVER"] = "Discover";
})(Screen || (Screen = {}));
export var ScreenExternal;
(function (ScreenExternal) {
    ScreenExternal["HELP"] = "Help";
    ScreenExternal["GUIDELINES"] = "Guidelines";
    ScreenExternal["SUPPORT"] = "Support";
})(ScreenExternal || (ScreenExternal = {}));
export var CHARACTER_VISIBILITY;
(function (CHARACTER_VISIBILITY) {
    CHARACTER_VISIBILITY["PRIVATE"] = "private";
    CHARACTER_VISIBILITY["PERMANENTLY_PRIVATE"] = "permanently_private";
    CHARACTER_VISIBILITY["HIDDEN"] = "hidden";
    CHARACTER_VISIBILITY["PUBLIC"] = "public";
})(CHARACTER_VISIBILITY || (CHARACTER_VISIBILITY = {}));
export var CHARACTER_MODERATION_STATUS;
(function (CHARACTER_MODERATION_STATUS) {
    CHARACTER_MODERATION_STATUS["FIX_REQUIRED"] = "fix_required";
    CHARACTER_MODERATION_STATUS["REREVIEW_REQUIRED"] = "rereview_required";
    CHARACTER_MODERATION_STATUS["PENDING"] = "pending";
    CHARACTER_MODERATION_STATUS["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
    CHARACTER_MODERATION_STATUS["CLOSED"] = "closed";
})(CHARACTER_MODERATION_STATUS || (CHARACTER_MODERATION_STATUS = {}));
export var LOREBOOK_VISIBILITY;
(function (LOREBOOK_VISIBILITY) {
    LOREBOOK_VISIBILITY["PRIVATE"] = "private";
    LOREBOOK_VISIBILITY["PERMANENTLY_PRIVATE"] = "permanently_private";
    LOREBOOK_VISIBILITY["PUBLIC"] = "public";
    LOREBOOK_VISIBILITY["HIDDEN"] = "hidden";
})(LOREBOOK_VISIBILITY || (LOREBOOK_VISIBILITY = {}));
